import { ServiceLayout } from "@/components/service/ServiceLayout";
import { ServiceFAQ } from "@/components/service/ServiceFAQ";
import { HeroSection } from "@/components/ecommerce/HeroSection";
import { FeaturesGrid } from "@/components/ecommerce/FeaturesGrid";
import { StatsSection } from "@/components/ecommerce/StatsSection";
import { ProcessSection } from "@/components/ecommerce/ProcessSection";
import { ServiceCTA } from "@/components/ui/ServiceCTA";
import { serviceFAQs } from "@/data/service-faqs";

const Ecommerce = () => {
  return (
    <ServiceLayout serviceName="E-commerce">
      <HeroSection />
      <StatsSection />
      <FeaturesGrid />
      <ProcessSection />
      <ServiceFAQ faqs={serviceFAQs["ecommerce"]} serviceName="E-commerce" />
      <ServiceCTA serviceName="E-commerce" />
    </ServiceLayout>
  );
};

export default Ecommerce;